import script from "./WidgetState.vue?vue&type=script&lang=ts&setup=true"
export * from "./WidgetState.vue?vue&type=script&lang=ts&setup=true"

import "./WidgetState.vue?vue&type=style&index=0&id=313a2406&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313a2406"]])

export default __exports__